import React from 'react';
import BillToFacility from './BillToFacility.validations';

const BillToFacilityContainer = props => {
  const handleInputChange = event => {
    const changeObj = {
      coordinationTypeId: window.ambulnzConfig.coordinationTypes.SUPPLEMENTAL,
      [event.target.name]: event.target.value,
    };

    props.setPayerInfo(changeObj);
  };

  const handleInputBlur = () => {
    props.autoSavePayerInfo();
  };

  return <BillToFacility {...props} onInputChange={handleInputChange} onInputBlur={handleInputBlur} />;
};

export default BillToFacilityContainer;
